import React from 'react';

import NotificationView from './NotificationView';

import { useMessageData, useNotification } from './hooks';

import { setDismissNotificationMessage } from './helpers';

import { INotification } from './interfaces';
import { StorageTypes } from '../../interfaces/storage';

const Notification = ({
  ref,
  id,
  title = '',
  message,
  type,
  withReloadButton = false,
  withDismissButton = true,
  storageType = StorageTypes.Local,
  dismissButtonText,
  reloadPageText,
  dismissButtonAction,
  reloadPageAction,
}: INotification) => {
  const { hideNotification } = useNotification();
  const { icon, color, colorIcon, background } = useMessageData(type);

  const reloadPage = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setDismissNotificationMessage(message, storageType);
    handleClickClose();
  };

  const handleClickClose = () => hideNotification(id);

  return (
    <NotificationView
      ref={ref}
      title={title}
      message={message}
      color={color}
      colorIcon={colorIcon}
      background={background}
      icon={icon}
      reloadPage={reloadPage}
      onDismiss={handleDismiss}
      withReloadButton={withReloadButton}
      withDismissButton={withDismissButton}
      onClickClose={handleClickClose}
      dismissButtonText={dismissButtonText}
      reloadPageText={reloadPageText}
      dismissButtonAction={dismissButtonAction}
      reloadPageAction={reloadPageAction}
    />
  );
};

export default Notification;
